import { dataService } from 'App';

const blackListUrl = '/users/blacklist';
/**
 *
 * @param {object} data info about user
 * @return {object} otp of users / error
 */
export function getBlackListOptOut() {

  return dataService.get(
    `${blackListUrl}/list/optOut`,
  );
}

export function getBlackListOptIn() {

  return dataService.get(
    `${blackListUrl}/list/optIn`,
  );
}

export function addOptOut(data) {

  return dataService.put(
    `${blackListUrl}/optOut`, data, {}
  );
}

export function addOptIn(data) {

  return dataService.put(
    `${blackListUrl}/optIn`, data, {}
  );
}

export function exportOptOut(data) {

  return dataService.post(
    `${blackListUrl}/optOut/export`,null, {header:{responseType: 'blob'}}
  );
}

export function exportOptIn() {

  return dataService.post(
    `${blackListUrl}/optIn/export`,null, {header:{responseType: 'blob'}}
  );
}

export function addNumbersToBlacklist(file) {
  let form = new FormData();
  form.append("file",file);
  return dataService.post(
    `${blackListUrl}/import`, form,
  );
}